import createIcon from '../../createIcon';

/**
 * @component @name BedtimeOff
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEuODk5NiAyMC44Nzg1TDMuNTE5NjEgMi40OTg0OEwyLjA5OTYxIDMuOTA4NDhMNC4zNjk2MSA2LjE3ODQ4QzMuMzE5NjEgNy43Njg0OCAyLjcwOTYxIDkuNjU4NDggMi43MDk2MSAxMS42ODg1QzIuNzA5NjEgMTcuMjA4NSA3LjE4OTYxIDIxLjY4ODUgMTIuNzA5NiAyMS42ODg1QzE0Ljc0OTYgMjEuNjg4NSAxNi42Mzk2IDIxLjA2ODUgMTguMjE5NiAyMC4wMjg1TDIwLjQ4OTYgMjIuMjk4NUwyMS44OTk2IDIwLjg3ODVaIiBmaWxsPSJibGFjayIvPgo8cGF0aCBkPSJNMTMuMDQ5NiAxLjcwODQ4QzEwLjg2OTYgMS42Mzg0OCA4Ljg1OTYxIDIuMjU4NDggNy4xOTk2MSAzLjM0ODQ4TDExLjc4OTYgNy45Mzg0OEMxMS41MTk2IDUuODg4NDggMTEuODg5NiAzLjcxODQ4IDEzLjA0OTYgMS43MDg0OFoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const BedtimeOff = createIcon('BedtimeOff', [
  [
    'path',
    {
      d: 'M21.8996 20.8785L3.51961 2.49848L2.09961 3.90848L4.36961 6.17848C3.31961 7.76848 2.70961 9.65848 2.70961 11.6885C2.70961 17.2085 7.18961 21.6885 12.7096 21.6885C14.7496 21.6885 16.6396 21.0685 18.2196 20.0285L20.4896 22.2985L21.8996 20.8785Z',
      key: '12ncgp',
    },
  ],
  [
    'path',
    {
      d: 'M13.0496 1.70848C10.8696 1.63848 8.85961 2.25848 7.19961 3.34848L11.7896 7.93848C11.5196 5.88848 11.8896 3.71848 13.0496 1.70848Z',
      key: '1jzeg8',
    },
  ],
]);

export default BedtimeOff;
